<template>
  <div class="tax-type-modal">
    <form action="" @submit.prevent="submitformTemplate" enctype="multipart/form-data">
      <div class="card-body">
        <div class="form-group row">
          <label class="col-sm-4 col-form-label input-label">{{ $t('user_guides.name') }} <span class="text-danger"> *</span></label>
          <div class="col-sm-7">
            <base-input
              ref="name"
              v-model="formTemplate.name"
              type="text"
              @input="$v.formTemplate.name.$touch()"
            />
            <div v-if="$v.formTemplate.name.$error">
              <span v-if="!$v.formTemplate.name.required" class="form-group__message text-danger">{{ $tc('validation.name_required') }}</span>
              <span v-if="!$v.formTemplate.name.minLength" class="form-group__message text-danger"> {{ $tc('validation.name_min_length', $v.formTemplate.name.$params.minLength.min, { count: $v.formTemplate.name.$params.minLength.min }) }} </span>
            </div>
          </div>
        </div>
      
        <div class="form-group row">
            <label class="col-sm-4 col-form-label input-label">{{ $t('user_guides.document') }} <span class="text-danger"> *</span></label>
            <div class="col-sm-7">
            <input   v-if="isEdit==false" ref="file" @change="onFileChange" type="file" @input="$v.formTemplate.document.$touch()"  >
            <input  v-else ref="file" @change="onFileChange" type="file">
            <br>
            <span class="form-group__message text-danger">{{  $t('user_guides.documentSizelessthan20MB') }}</span>
            <div v-if="isEdit==false && $v.formTemplate.document.$error">
              <span v-if="!$v.formTemplate.document.required" class="form-group__message text-danger">{{ $tc('validation.required') }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="card-footer">
        <base-button
          :outline="true"
          class="mr-3"
          color="theme"
          type="button"
          @click="closeUserGuideModal"
        >
          {{ $t('general.cancel') }}
        </base-button>
        <base-button
          :loading="isLoading"
          :disabled="isSubmitDisabled"
          color="theme"
          icon="save"
          type="submit"
        >
          {{ !isEdit ? $t('general.save') : $t('general.update') }}
        </base-button>
      </div>
    </form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { validationMixin } from 'vuelidate'
const { required, minLength, between, maxLength } = require('vuelidate/lib/validators')
export default {
  mixins: [validationMixin],
  data () {
    return {
      isEdit: false,
      isLoading: false,
      formTemplate: {
        id: null,
        name:null,
        document:null,
        status:null
      },
      selectedFile: null,
    }
  },
  computed: {
    ...mapGetters('modal', [
      'modalDataID',
      'modalData',
      'modalActive'
    ]),
    isSubmitDisabled() {
      return this.$v.$invalid
    }
  },
  validations() {
    if(!this.isEdit){
      return {
        formTemplate: {
          name: {
            required,
            minLength: minLength(3)
          },
          document: {
            required,
          }
        },
      }
    }else{
      return {
        formTemplate: {
          name: {
            required,
            minLength: minLength(3)
          },
          id: {
            required
          }
        },
      }
    }
  },
  async mounted () {
    this.$refs.name.focus = true
    if (this.modalDataID) {
      this.isEdit = true
      this.setData()
    }
  },
  methods: {
    ...mapActions('modal', [
      'closeModal',
      'resetModalData'
    ]),
    ...mapActions('islamicFormTemplate', [
      'updateFormTemplate',
      'addFormTemplate'
    ]),
    resetFormData () {
      this.formTemplate = {
        id: null,
        document: null,
        status:null,
        name:null
      }
      this.$v.formTemplate.$reset()
    },
    onFileChange (e) {
        if(e.target.files[0].size >=1048576*20){
          window.toastr['error'](this.$t('user_guides.documentSizeExceed20MB'));
          //this.$refs.file.value = '';
           this.isLoading = false
        }else{
            this.isLoading = true
            this.selectedFile = e.target.files[0];
            this.formTemplate.document=e.target.files[0];
            this.isLoading = false
       }
    },
    async submitformTemplate () {
        this.$v.formTemplate.$touch()
        if (this.$v.$invalid) {
            return true
        }
        this.isLoading = true
        let response
        let DocumentData = new FormData();
        if (!this.isEdit) {
          DocumentData.append('name',this.formTemplate.name);
          DocumentData.append('status',this.formTemplate.status);
          DocumentData.append('document', this.selectedFile)
          response = await this.addFormTemplate(DocumentData)
        }
        if (response.data) {
          if (!this.isEdit) {
            window.toastr['success'](this.$t('islamic_finance_form_template.created_message'))
          } else {
            window.toastr['success'](this.$t('islamic_finance_form_template.updated_message'))
          }
          this.$router.go('/super-admin/islamic_finance_forms')
          this.closeUserGuideModal()
          this.isLoading = false
          return true
        }
        window.toastr['error'](response.data.error)
    },
    async setData () {
      this.formTemplate = {
        id: this.modalData.id,
        name: this.modalData.name,
        status: this.modalData.status
      }
    },
    closeUserGuideModal () {
        this.resetModalData()
        this.resetFormData()
        this.closeModal()
    }
  }
}
</script>
